import { cn } from '@/lib/cn';
import type { Position } from '@/types';

/**
 * Position colours are keyed to the position itself, so GK always reads the
 * same across the app.
 */
const POSITION_STYLES: Record<Position, string> = {
  GK: 'bg-position-gk',
  DEF: 'bg-position-def',
  MID: 'bg-position-mid',
  FWD: 'bg-position-fwd',
};

export interface PositionBadgeProps {
  position: Position;
  className?: string;
}

export function PositionBadge({ position, className }: PositionBadgeProps) {
  return (
    <span
      className={cn(
        'grid size-6 shrink-0 place-items-center rounded-badge text-[8px] font-extrabold text-white',
        POSITION_STYLES[position],
        className,
      )}
    >
      {position}
    </span>
  );
}

/** Neutral badge for club initials on fixture rows. */
export function ClubBadge({ club, className }: { club: string; className?: string }) {
  return (
    <span
      className={cn(
        'grid size-6 shrink-0 place-items-center rounded-badge bg-position-def text-[8px] font-extrabold text-white',
        className,
      )}
    >
      {club.slice(0, 2).toUpperCase()}
    </span>
  );
}
